/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DropTwitchScheduleSegmentResponse
 */
export interface DropTwitchScheduleSegmentResponse {
    /**
     * 
     * @type {string}
     * @memberof DropTwitchScheduleSegmentResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof DropTwitchScheduleSegmentResponse
     */
    startTime: string;
    /**
     * 
     * @type {string}
     * @memberof DropTwitchScheduleSegmentResponse
     */
    endTime: string;
    /**
     * 
     * @type {string}
     * @memberof DropTwitchScheduleSegmentResponse
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof DropTwitchScheduleSegmentResponse
     */
    canceledUntil?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DropTwitchScheduleSegmentResponse
     */
    categoryName?: string;
}

/**
 * Check if a given object implements the DropTwitchScheduleSegmentResponse interface.
 */
export function instanceOfDropTwitchScheduleSegmentResponse(value: object): value is DropTwitchScheduleSegmentResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('startTime' in value) || value['startTime'] === undefined) return false;
    if (!('endTime' in value) || value['endTime'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    return true;
}

export function DropTwitchScheduleSegmentResponseFromJSON(json: any): DropTwitchScheduleSegmentResponse {
    return DropTwitchScheduleSegmentResponseFromJSONTyped(json, false);
}

export function DropTwitchScheduleSegmentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DropTwitchScheduleSegmentResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'startTime': json['startTime'],
        'endTime': json['endTime'],
        'title': json['title'],
        'canceledUntil': json['canceledUntil'] == null ? undefined : json['canceledUntil'],
        'categoryName': json['categoryName'] == null ? undefined : json['categoryName'],
    };
}

export function DropTwitchScheduleSegmentResponseToJSON(json: any): DropTwitchScheduleSegmentResponse {
    return DropTwitchScheduleSegmentResponseToJSONTyped(json, false);
}

export function DropTwitchScheduleSegmentResponseToJSONTyped(value?: DropTwitchScheduleSegmentResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'startTime': value['startTime'],
        'endTime': value['endTime'],
        'title': value['title'],
        'canceledUntil': value['canceledUntil'],
        'categoryName': value['categoryName'],
    };
}

